import { CheckCircle2, ShieldAlert, ShieldCheck } from "lucide-react";
import { formatGal, formatToEighths } from "@/lib/tank";

const HEAD = { safe: "Fits. Level checks out.", caution: "Check before you open the valves.", critical: "STOP. This drop won't fit." };

function Checks({ v, ullage, t }) {
  const rows = [
    v.overflow ? [false, t("This drop is more than the whole tank holds.")]
      : [v.methodsAgree, v.methodsAgree ? t("Second check agrees (by gallons per inch: +{g}).", { g: formatToEighths(v.gpiGain) })
      : t("Second check disagrees by {o}. Recheck the tank size and diameter.", { o: formatToEighths(v.gainOff) })],
  ];
  if (ullage > 0) {
    rows.push([v.roomLeft >= 0, v.roomLeft >= 0 ? t("{r} gal of console ullage left after the drop.", { r: formatGal(v.roomLeft) })
      : t("Over the console ullage by {r} gal.", { r: formatGal(-v.roomLeft) })]);
    rows.push([v.ullageMatches, v.ullageMatches ? t("Console ullage matches this tank size.")
      : t("Console says {u} gal of room, this tank size says {a} gal. The tank size may be wrong.", { u: formatGal(ullage), a: formatGal(v.appRoom) })]);
  }
  return rows.map(([ok, text], i) => (
    <div key={i} className={`verify-check ${ok ? "ok" : "bad"}`} data-testid={`verify-check-${i}`}>
      {ok ? <ShieldCheck size={15} /> : <ShieldAlert size={15} />}<span>{text}</span>
    </div>
  ));
}

export function VerifyResult({ v, ullage, confirmed, onConfirm, t }) {
  return (
    <div className={`card verify-result verify-${v.tone}`} data-testid="verify-result">
      <div className="verify-head" data-testid="verify-status">{t(HEAD[v.tone])}</div>
      <div className="label">{t("Projected stick after the drop")}</div>
      <div className="stick-big mono" data-testid="verify-final-inches">{v.overflow ? t("Over full") : formatToEighths(v.finalInches)}</div>
      <div className="card-sub mono" data-testid="verify-final-detail">
        {formatGal(v.finalGallons)} gal · {v.finalPct.toFixed(1)}% {t("full")} · +{formatToEighths(v.stickGain)}
      </div>
      <div className="card-sub mono" data-testid="verify-limits">{t("90% at {a} · 95% at {b}", { a: formatToEighths(v.h90), b: formatToEighths(v.h95) })}</div>
      <Checks v={v} ullage={ullage} t={t} />
      {v.tone !== "critical" && (confirmed
        ? <div className="verify-confirmed" data-testid="verify-confirmed"><CheckCircle2 size={16} />{t("Checked at {time}. Watch the stick as you drop.", { time: confirmed })}</div>
        : <button type="button" className="primary-btn" onClick={onConfirm} data-testid="verify-confirm-btn">
          <CheckCircle2 size={16} />{t("I checked the stick, BOL and ullage")}</button>)}
      <div className="scan-caution">{t("Estimate from a standard tank shape. The store's tank chart and the console come first.")}</div>
    </div>
  );
}
